import React from 'react';
import Moment from "react-moment";

const FormatDate = (props) => (
  <Moment format={props.format} className={props.className}>
    {props.date}
  </Moment>
);

export default FormatDate;